import { Tooltip, Typography, Badge } from '@mui/material';
import {
  ColumnsPanelTrigger,
  useGridApiContext,
  useGridSelector,
  gridColumnVisibilityModelSelector,
} from '@mui/x-data-grid-premium';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { TextButton } from '../Button';
import { useSharedTFunction } from '@shared/i18n';
import { getTogglableDataGridColumns } from '@shared/utils';
import { useMemo, memo, useRef } from 'react';

const CustomColumnMenuButtonComponent = () => {
  const t = useSharedTFunction();
  const apiRef = useGridApiContext();
  const columnVisibilityModel = useGridSelector(apiRef, gridColumnVisibilityModelSelector);
  const columnsRef = useRef(apiRef.current?.getAllColumns() || []);

  const { visibleCount, totalCount } = useMemo(() => {
    const allColumns = apiRef.current?.getAllColumns() || columnsRef.current;
    if (allColumns.length > 0) {
      columnsRef.current = allColumns;
    }
    const toggableColumns = getTogglableDataGridColumns(allColumns);

    const visible = toggableColumns.filter((field) => {
      return columnVisibilityModel[field] !== false;
    }).length;

    return {
      visibleCount: visible,
      totalCount: toggableColumns.length,
    };
  }, [apiRef, columnVisibilityModel]);

  const badgeContent = visibleCount < totalCount ? `${visibleCount}/${totalCount}` : null;

  return (
    <Tooltip title={t('shared.table.columns')}>
      <ColumnsPanelTrigger render={<TextButton color="primary" />}>
        <Badge badgeContent={badgeContent} color="primary">
          <ViewColumnIcon
            fontSize="small"
            color="primary"
            sx={{
              mr: 1,
            }}
          />
        </Badge>
        <Typography variant="body2">{t('shared.table.columns')}</Typography>
      </ColumnsPanelTrigger>
    </Tooltip>
  );
};

export const CustomColumnMenuButton = memo(CustomColumnMenuButtonComponent);
